const MANUAL_LANG_KEY = 'cadencez.lang.manual';

export function markManualLanguage(): void {
  try { localStorage.setItem(MANUAL_LANG_KEY, '1'); } catch { /* private mode */ }
}

export function isManualLanguage(): boolean {
  try { return localStorage.getItem(MANUAL_LANG_KEY) === '1'; } catch { return false; }
}
